import { YupSchema } from 'services/yup/types'
import { yupIgnore } from 'services/yup'
import { experienceVS } from './experience'
import { APIPriceRange } from 'services/api/entities/catalog/types'
import { VirtualExperience } from 'services/api/entities/catalog/virtual/types/internal/virtual-models'

export const virtualVS: YupSchema<
  VirtualExperience,
  APIPriceRange[] | undefined
> = experienceVS.shape({
  virtualCategoryFacet: yupIgnore(),
})
